<template>
  <v-btn @click.prevent="signOut" text>
    {{ $t("appbar.logout") }}
  </v-btn>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'


export default {
  name: 'logout',

  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
  },

  methods: {

    ...mapActions({
      signOutAction : 'auth/signOut',
      resetVictims  : 'victims/reset',
      resetScamas   : 'scamas/reset'
    }),

    async signOut () {
      //Leave Victim Channel
      window.Echo.leave('Victims.'+this.user.id);
      await this.signOutAction();
      this.$router.replace({ name: 'Welcome' });
      this.resetVictims();
      this.resetScamas();
    }
  }
};
</script>